import script from "./anchor-link.vue?vue&type=script&setup=true&lang=ts"
export * from "./anchor-link.vue?vue&type=script&setup=true&lang=ts"

import "./anchor-link.vue?vue&type=style&index=0&id=2e5d0bc2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5d0bc2"]])

export default __exports__